import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// API nat = "Tiger Winner", "Lion Pair", etc.
function findItem(sub, player, betLabel) {
  return sub.find((s) => s.nat === `${player} ${betLabel}`);
}

// range collapse — desktop me i pe float-right nahi (wrapper pe), mobile me i pe
function RangeCollapse({ rangeId, min, max, iFloat }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="float-right">
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle${iFloat ? ' float-right' : ''}${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <div id={rangeId} className={`collapse icon-range${open ? ' show' : ''}`}>
        {'\n                            R:'}
        <span>{fmtAmt(min ?? 100)}</span>
        -
        <span>{fmtAmt(max ?? 0)}</span>
      </div>
    </div>
  );
}

// { label, dMax(default max), dRange(desktop id), mRange(mobile id) }
const BET_TYPES = [
  { label: 'Winner',         dMax: 300000, dRange: 'range1', mRange: 'range0' },
  { label: 'Pair',           dMax: 25000,  dRange: 'range2', mRange: 'range1' },
  { label: 'Flush',          dMax: 10000,  dRange: 'range3', mRange: 'range2' },
  { label: 'Straight',       dMax: 10000,  dRange: 'range4', mRange: 'range3' },
  { label: 'Trio',           dMax: 5000,   dRange: 'range5', mRange: 'range4' },
  { label: 'Straight Flush', dMax: 5000,   dRange: 'range6', mRange: 'range5' },
];

const PLAYERS = ['Tiger', 'Lion', 'Dragon'];

const BetTableTeenpattiTest = memo(function BetTableTeenpattiTest({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const rangeItem = (bt) => findItem(sub, 'Tiger', bt.label);

  return (
    <>
      {/* ── DESKTOP (d-none-small) ── */}
      <div className="teen1daycasino-container d-none-small">
        <div className="teentestother">
          <div className="casino-box-row">
            <div className="casino-nation-name no-border"></div>
            {BET_TYPES.map((bt) => {
              const ri = rangeItem(bt);
              return (
                <div key={bt.label} className="casino-bl-box">
                  <div className="casino-bl-box-item">
                    <b>{bt.label}</b>
                    {' '}
                    <RangeCollapse rangeId={bt.dRange} min={ri?.min} max={ri?.max ?? bt.dMax} />
                  </div>
                </div>
              );
            })}
          </div>
          {PLAYERS.map((player) => (
            <div key={player} className="casino-box-row mb-4">
              <div className="casino-nation-name"><b>{player}</b></div>
              {BET_TYPES.map((bt) => {
                const item = findItem(sub, player, bt.label);
                const book = bookOf(exposures, item?.nat, item?.sid);
                return (
                  <div key={bt.label} className="casino-bl-box">
                    <div
                      className={`back casino-bl-box-item${suspCls(item)}`}
                      onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
                    >
                      <span className="casino-box-odd">{item?.b ?? 0}</span>
                      {' '}
                      <span className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* ── MOBILE (d-none-big) — bet types as rows, players as columns ── */}
      <div className="teen1daycasino-container d-none-big">
        <div className="casino-box-row teen1dayodev">
          <div className="casino-bl-box casino-bl-box-title">
            <div className="casino-bl-box-item casino-card-img"></div>
            {PLAYERS.map((p) => (
              <div key={p} className="casino-bl-box-item"><b>{p}</b></div>
            ))}
          </div>
          {BET_TYPES.map((bt) => {
            const ri = rangeItem(bt);
            return (
              <div key={bt.label} className="casino-bl-box">
                <div className="casino-bl-box-item casino-odds-name">
                  <span>{bt.label}</span>
                  {' '}
                  <RangeCollapse rangeId={bt.mRange} min={ri?.min} max={ri?.max ?? bt.dMax} iFloat />
                </div>
                {PLAYERS.map((player) => {
                  const item = findItem(sub, player, bt.label);
                  const book = bookOf(exposures, item?.nat, item?.sid);
                  return (
                    <div
                      key={player}
                      className={`back casino-bl-box-item${suspCls(item)}`}
                      onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
                    >
                      <span className="casino-box-odd">{item?.b ?? 0}</span>
                      {' '}
                      <span className={bookCls(book)}>{fmtBook(book)}</span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

export default BetTableTeenpattiTest;
